import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  constructor(private http: HttpClient) {}

  public getAllFacilitiesWithArea(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/user/facilities`, {});
  }
}
